import "./modules/import-jquery";

import { Menu } from './modules/Menu';
import { Slider } from "./modules/Slider";
import { Dropdown } from './modules/Dropdown';
import { Datepicker } from "./modules/Datepicker";
import { jarallax } from 'jarallax';
import Macy from 'macy';

require("@fancyapps/fancybox");

import { entryCardsCarousel } from "./modules/Slider";
import { eventsCarousel } from "./modules/Slider";
import { imprezyListaCarousal } from "./modules/Slider";

const topbar = document.querySelector('.topbar');

class App {
	constructor() {
		this.init();
	}

	init() {
		const menu = new Menu();
		const slider = new Slider();
		const dropdown = new Dropdown();
		const datepicker = new Datepicker();

		this.navScrollClass();
		this.siteContrast();
		this.masonryGalleries();
		this.searchBox();
		this.parallax();
		this.fancyGallery();
		
		/*
		$("div.entry__content img:not(.pp_gal)").each(function () {
			if (!jQuery(this).parent().is('figure')) {
				var img_alt = jQuery(this).attr('alt');
				if (img_alt) {
					jQuery(this).wrap(jQuery('<figure/>', {
						'class': jQuery(this).attr('class'),
						'style': jQuery(this).attr('style')
					}));
					jQuery(this).after(jQuery('<figcaption/>').append(img_alt));
				}
			}
		});		
		*/
	}

	navScrollClass() {
		let initScrollPos = document.documentElement.scrollTop;
		if (initScrollPos > 100) {
			topbar.classList.add('is-scrolled');
		}

		window.addEventListener('scroll', () => {
			let scrollPos = window.scrollY;
			if (scrollPos > 100) {
				topbar.classList.add('is-scrolled');
			} else {
				topbar.classList.remove('is-scrolled');
			}
		});
	}

	smoothScrollToAnchor() {
		let url = window.location.hash;
		if (url) {
			window.scrollTo(0, 0);
			$('html, body').animate({
				scrollTop: $(url).offset().top - 100
			}, 1000);
		}
	}

	parallax() {
		jarallax(document.querySelectorAll('.jarallax'), {
			speed: 0.2
		});
	}

	siteContrast() {
		let constrastButton = $('#contrastButton');
		let body = $(document.body);
		constrastButton.on('click', function () {
			body.toggleClass('has-contrast');
			constrastButton.toggleClass('is-active');
		});
	}

	masonryGalleries() {
		const masonryGalleries = document.getElementById('masonryGalleries');
		if (masonryGalleries) {
			let macyInstance = Macy({
				container: "#masonryGalleries",
				margin: 60,
				columns: 3,
				breakAt: {
					1500: {
						margin: 50
					},
					1200: {
						margin: 40,
					},
					992: {
						margin: 30,
					},
					768: {
						columns: 2
					},
					576: {
						columns: 1
					}
				}
			});
		}
	}
	
	fancyGallery() {
		let fancy = $('[data-fancybox="gallery"]').fancybox({
			buttons: [
				//"zoom",
				//"share",
				//"slideShow",
				"fullScreen",
				//"download",
				//"thumbs",
				"close"
			 ]
		});
	}

	searchBox() {
		const searchBoxTrigger = $('#searchBoxTrigger');
		const searchBox = $('.search-box');
		const searchBoxClose = $('.search-box__close');
		const searchFormDots = $('.search-form__dot');
		const searchFormField = $('.search-form__field');

		function fadeOutSearchBox() {
			searchFormDots.each(function (index, element) {
				setTimeout(function () {
					$(element).animate({opacity: 0, top: 10}, 300);
				}, 50 * index);
			});
			setTimeout(() => searchBox.fadeOut('fast'), 800);
		}

		searchBoxTrigger.on('click', function () {
			searchBox.fadeIn('fast');
			searchFormField.focus();
			//searchFormField.val(null);
			searchFormDots.each(function (index, element) {
				setTimeout(() => $(element).animate({opacity: 1, top: 0}, 300), 75 * index);
			});
		});

		searchBoxClose.on('click', fadeOutSearchBox);
	}
}

const app = new App;

var kdGalLista = 0;
window.kdGaleria = function ()
{
	kdGalLista++;
	$.ajax({
		url: "/index.php",
		method: "post",
		dataType: "json",
		data: {
			a: 'galeria-albumy',
			l: kdGalLista
		},
		success: function (response) {
			if (response == '') {
				$('.load-more').hide();
			} else {
				$('#masonryGalleries').append(response);
				app.masonryGalleries();
			}
		}
	});
}

var kdGalZdjecia = 0;
window.kdGaleriaZdjecia = function (k)
{
	kdGalZdjecia++;
	$.ajax({
		url: "/index.php",
		method: "post",
		dataType: "json",
		data: {
			a: 'galeria-zdjecia',
			k: k,
			l: kdGalZdjecia
		},
		success: function (response) {
			if (response == '') {
				$('.load-more').hide();
			} else {
				$('#masonryGalleries').append(response);
				app.masonryGalleries();
				app.fancyGallery();
			}
		}
	});

}


window.kdSgNews = function (k) {
	$('#kdnk').text($('#kdnk' + k).find('a').text());
	$('#kdnmb').attr('href', $('#kdnk' + k).find('a').attr('data-link'));

	$.ajax({
		url: "/index.php",
		method: "post",
		dataType: "json",
		data: {
			a: 'strona-glowna-news',
			k: k
		},
		success: function (response) {
			$('.sgnews').html(response);

			entryCardsCarousel.update(true);
		}
	});
}

var sgImpK = 0;
var sgImpD = 0;
window.kdSgImp = function (k, f) {
	if (f == 1) {
		sgImpD = k;
	} else if (f == 0) {
		sgImpK = k;
	}

	if (sgImpD != 0) {
		$('#kdimk').text($('#kdimk' + sgImpK).text() + ' (' + sgImpD + ')');
	} else {
		$('#kdimk').text($('#kdimk' + sgImpK).text());
	}
	$('#kdimb').attr('href', $('#kdimk' + sgImpK).attr('data-link'));


	$.ajax({
		url: "/index.php",
		method: "post",
		dataType: "json",
		data: {
			a: 'strona-glowna-imp',
			k: sgImpK,
			d: sgImpD
		},
		success: function (response) {
			$('.sgimp').html(response);

			eventsCarousel.update(true);
		}
	});
}

var newsMoreEntries = 0;
window.kdNewsMoreEntries = function (k, d) {
	newsMoreEntries++;
	$.ajax({
		url: "/index.php",
		method: "post",
		dataType: "json",
		data: {
			a: 'news-more-entries',
			k: k,
			d: d,
			l: newsMoreEntries
		},
		success: function (response) {
			if (response == '') {
				$('.load-more').hide();
			} else {
				$('#newsloadMoreEntries').append(response);
			}
		}
	});
}

var imprezyMoreEntries = 0;
window.kdImprezyMoreEntries = function (k, d) {
	imprezyMoreEntries++;
	$.ajax({
		url: "/index.php",
		method: "post",
		dataType: "json",
		data: {
			a: 'imprezy-more-entries',
			k: k,
			d: d,
			l: imprezyMoreEntries
		},
		success: function (response) {
			console.log(response.cars)

			if (response.cars.length == 0) {
				$('.load-more').hide();
			} else {
				$('#imprezyloadMoreEntries').append(response.html);

				for (var i = 0; i < response.cars.length; i++) {
					imprezyListaCarousal(response.cars[i]);

					console.log(response.cars[i]);
				}
			}
		}
	});
}
